export const getFoundationAddresses = (dispatch: any) =>
  dispatch({ type: "GET_FOUNDATIONADDRESSES" });

export const getFoundationAddressesSuccess = (stats: any[]) => ({
  type: "GET_FOUNDATIONADDRESSES_SUCCESS",
  stats,
});

export const getFoundationAddressesFailure = (error: Error) => ({
  type: "GET_FOUNDATIONADDRESSES_FAILURE",
  error,
});
